module.exports = __webpack_public_path__ + "img/content6-2.9b417817.webp";